'use client'

import { UserContext } from '@/providers/user-provider'
import { ReactNode, use } from 'react'

interface Props {
    children: ReactNode
}

export const HiddenWhenFetchingUser = ({ children }: Props): ReactNode | undefined => {
    const { isLoading } = use(UserContext)

    if (isLoading) return null

    return children
}

export const HiddenWhenNotFetchingUser = ({ children }: Props): ReactNode | undefined => {
    const { isLoading } = use(UserContext)

    if (!isLoading) return null

    return children
}
